// src/pages/settings/settingsRow.js
import React from "react";

const SettingsRow = ({ label, children, fullWidth = false }) => (
  <div className={`stg-row ${fullWidth ? "full-width" : ""}`}>
    <span className="stg-label">{label}</span>
    <div className="stg-control">{children}</div>
  </div>
);

export default SettingsRow;
